import { DetailedHTMLProps, forwardRef, InputHTMLAttributes, ReactNode } from 'react';

import { classNames } from 'support/helpers/generic/generic';
import { Checkbox } from 'components/Form/Checkbox/Checkbox';
import { FieldsetLegend } from 'components/Form/Input/FieldsetLegend/FieldsetLegend';

const CheckboxGroupGroup = ({
  children,
  label,
  legendVariant,
  required,
  className,
  description,
}: {
  children: ReactNode;
  label?: string;
  legendVariant?: 'default' | 'large';
  required?: boolean;
  className?: string;
  description?: ReactNode;
}) => {
  return (
    <fieldset className={classNames('mt-4', className)}>
      <FieldsetLegend
        label={label}
        description={description}
        variant={legendVariant}
        required={required}
        className="mb-2"
      />
      <div className="space-y-3">{children}</div>
    </fieldset>
  );
};

type CheckboxGroupItemProps = {
  label: ReactNode;
  hasErrors?: boolean;
} & Omit<
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
  'type' | 'id' | 'className' | 'ref'
>;

const CheckboxGroupItem = forwardRef<HTMLInputElement, CheckboxGroupItemProps>(
  ({ label, hasErrors, ...inputProps }, ref) => {
    return <Checkbox ref={ref} label={label} error={hasErrors} {...inputProps} />;
  },
);

CheckboxGroupItem.displayName = 'CheckboxGroupItem';

export const CheckboxGroup = Object.assign({}, { Group: CheckboxGroupGroup, Item: CheckboxGroupItem });
